<template>
    <div class="col-12 no-gutters container mt-3">
        <div class="e-chart-container">
            <div class="title-and-chart">
                <div :id="eChartId" class="e-chart">
                    <chart :options="chart.options"></chart>
                </div>
                <div :id="eChartMiniId">
                    <img :src="imageUrl" class="pdf-content-image-width hidden-dashboard-display"/>
                </div>             
            </div>
        </div>
    </div>
</template>

<script>
import ScatterService from "../../services/echarts/scatter.service";
import ReportService from "../../services/report.service";
import ProfileService from "../../services/echarts/profile.service";
import NeedsService from "../../services/needs.service";
import EChartsMixins from "../../mixins/EChartsMixins";

import $, { isEmptyObject } from "jquery";

export default {
  name: "ProfileChart",
  mixins: [EChartsMixins],
  components: {},
  data() {
    return {
        charts: [],
        legend : [],
        colors: [],
        emotionalNeedsNameOrder: [],
        driverNames: [],
        displayPricingPower: false,
        pricingPowerSeriesNumber: 0,
        relativeStrengthList: [],
        liftList: [],
        emotionalNeedNamesMap: [],
        addWrapper: false,
        maxPricingPower: 0,
        maximumAxisLabelWidth: 0,
        pricingPowerColor : "rgb(215, 228, 189)",
        totalCharacters: 0,
        matchType: "",
        verbatimsData: {},
        topAttributeRecommendations: {},
        topAttributeRecommendationsLegendName: "Value Suggestions",
    };
  },
  props: {
    inputDownloadFileName: {
      type: String,
      default: "Profile"
    },
  },
  computed: {
    yAxisForChart2: function(){
        return this.displayPricingPower == true ? 2 : 1;
    }, 
    yAxisForPricingPowerChart2: function(){
         return this.displayPricingPower == true ? 3 : 2;
    }
  },
  mounted() {},
  created() {},
  methods: {
    //https://codepen.io/plainheart/pen/bGgmGPj    
    setDataForNeed: function(needsData,chart1,chart2 = {},displayType,emotionalNeedNames){
        let chart1Data = {};
        let chart2Data = {};
        let listOfDimensionsThatNeedLabelsFlipped = emotionalNeedNames.filter(name => typeof name.flipLabelsForDimension != "undefined" && name.flipLabelsForDimension == true).map(name => name.dimensionName);
        let finalDimensionTopLabels = ProfileService.getFinalDimensionTopLabels(listOfDimensionsThatNeedLabelsFlipped);
        let dimensionTopLabelFirst = finalDimensionTopLabels.finalDimensionTopLabelFirst;
        let dimensionTopLabelSecond = finalDimensionTopLabels.finalDimensionTopLabelSecond;

        this.setDataForBaseChart(needsData,chart1,chart2,displayType);        
        if (typeof needsData != "undefined" && !$.isEmptyObject(needsData)) {
            if (typeof needsData.chart1 != "undefined" && needsData.chart1.data.length > 0){
                chart1Data = JSON.parse(JSON.stringify(needsData.chart1));
                if (typeof needsData.chart1.containerId != "undefined"){
                    chart1.containerId = needsData.chart1.containerId;
                }
                if (typeof needsData.chart1.additionalSeries != "undefined"){
                    chart1.additionalSeries = needsData.chart1.additionalSeries;
                }
                if (typeof needsData.chart1.relativeStrengthSeriesIndexList != "undefined"){
                    chart1.relativeStrengthSeriesIndexList = needsData.chart1.relativeStrengthSeriesIndexList;
                }
                if (typeof needsData.chart1.isPositiveCorrelation != "undefined"){
                    chart1.isPositiveCorrelation = needsData.chart1.isPositiveCorrelation;
                }
                if (typeof needsData.chart1.relativeStrengthIndex != "undefined"){
                    chart1.relativeStrengthIndex = needsData.chart1.relativeStrengthIndex;
                }
            }
            if (typeof needsData.chart2 != "undefined" && needsData.chart2.data.length > 0){
                chart2Data = JSON.parse(JSON.stringify(needsData.chart2));
                if (typeof needsData.chart2.containerId != "undefined"){
                    chart2.containerId = needsData.chart2.containerId;
                }
                if (typeof needsData.chart2.additionalSeries != "undefined"){
                    chart2.additionalSeries = needsData.chart2.additionalSeries;
                }
                if (typeof needsData.chart2.relativeStrengthSeriesIndexList != "undefined"){
                    chart2.relativeStrengthSeriesIndexList = needsData.chart2.relativeStrengthSeriesIndexList;
                }         
                if (typeof needsData.chart2.isPositiveCorrelation != "undefined"){
                    chart2.isPositiveCorrelation = needsData.chart2.isPositiveCorrelation;
                }
                if (typeof needsData.chart2.relativeStrengthIndex != "undefined"){
                    chart2.relativeStrengthIndex = needsData.chart2.relativeStrengthIndex;
                }
            }            
            if (typeof needsData.relativeStrengthList != "undefined"){
                this.relativeStrengthList = JSON.parse(JSON.stringify(needsData.relativeStrengthList));
            } else {
                this.relativeStrengthList = [];
            }
            if (typeof needsData.liftList != "undefined"){
                this.liftList = JSON.parse(JSON.stringify(needsData.liftList));
            } else {
                this.liftList = [];
            }
            if (typeof needsData.emotionalNeedNamesMap != "undefined"){
                this.emotionalNeedNamesMap = JSON.parse(JSON.stringify(needsData.emotionalNeedNamesMap));
            } else {
                this.emotionalNeedNamesMap = [];
            }
            if (typeof needsData.pricingPowerSeriesNumber != "undefined"){
                this.pricingPowerSeriesNumber = JSON.parse(JSON.stringify(needsData.pricingPowerSeriesNumber));
                this.pricingPowerSeriesNumber = Number(this.pricingPowerSeriesNumber);
                this.displayPricingPower = true;
            } else {
                this.displayPricingPower = false;
                this.pricingPowerSeriesNumber = 0;
            }
            if (typeof needsData.displayPricingPower != "undefined"){
                this.displayPricingPower = needsData.displayPricingPower;
            } else {
                this.displayPricingPower = false;
                this.pricingPowerSeriesNumber = 0;
            }
        }
        let displayedLegend = [];
        let displayNumberOfRespondents = this.eChartCriteria.displayNumberOfResponses;
        if (displayNumberOfRespondents && typeof this.legend.respondents != "undefined"){
            displayedLegend = JSON.parse(JSON.stringify(this.legend.respondents));
        } else {
            displayedLegend = JSON.parse(JSON.stringify(this.legend.normal));
        }
        if (displayType == "value-driver" || displayType == "match-value-driver") {
            if (displayNumberOfRespondents && typeof this.legend.respondents != "undefined"){
                displayedLegend = JSON.parse(JSON.stringify(this.legend.respondents));
            } else {
                displayedLegend = JSON.parse(JSON.stringify(this.legend.normal));
            }
        }
        let liftLegends = [];
        for (let legendIndex = 0; legendIndex < displayedLegend.length; legendIndex++) {
            let legend = displayedLegend[legendIndex];
            let legendName = legend.elementId === "reposition"
                ? "Reposition"
                : legend.elementId === "in-demand" ? "In-Demand" : legend.name;
            if (legend.elementId === "reposition" || legend.elementId === "in-demand") {
                legend.name = legendName;
            }
            if (legendIndex == 0){
                let chart1Series = ProfileService.getSeries(legendName,0,0,0,ProfileService.getExpectationsConfig(chart1.containerId));
                if (displayType == "winner" || displayType == "match-winner"){  
                    $.extend(true, chart1Series, ProfileService.getMarkPointForEmotionalNeeds(true,this.emotionalNeedNamesMap,dimensionTopLabelFirst,dimensionTopLabelSecond));
                }
                chart1.series.push(chart1Series);
                if (!$.isEmptyObject(chart2)){                
                    let chart2Series = ProfileService.getSeries(legendName,1,2,this.yAxisForChart2,ProfileService.getExpectationsConfig(chart2.containerId),chart2.containerId);
                    chart2.series.push(chart2Series);
                }
            } else if (legendIndex == 1){
                chart1.series.push(ProfileService.getSeries(legendName,0,0,0,ProfileService.getDefaultClientSymbolConfig(this.symbolType)));
                if (!$.isEmptyObject(chart2)){                
                    chart2.series.push(ProfileService.getSeries(legendName,1,2,this.yAxisForChart2,ProfileService.getDefaultClientSymbolConfig(this.symbolType)));
                }
            } else if (this.displayPricingPower && (legendIndex == this.pricingPowerSeriesNumber-1)){
                if (this.colors.length > (this.pricingPowerSeriesNumber-1)) {
                    this.pricingPowerColor = this.colors[this.pricingPowerSeriesNumber-1];
                }
                chart1.series.push(ProfileService.getPricingPowerSeries(0,0,1,this.pricingPowerColor));
                if (!$.isEmptyObject(chart2)){                
                    chart2.series.push(ProfileService.getPricingPowerSeries(1,2,this.yAxisForPricingPowerChart2,this.pricingPowerColor));
                }
            } else {
                let isMatch = (this.matchType == "time-period" || this.matchType == "saved-card" || this.matchType == "survey")? true : false;
                let symbolSize = isMatch ? 13 : 10;
                if (typeof legend.elementId !== 'undefined' && (legend.elementId === "reposition" || legend.elementId === "in-demand")){
                    liftLegends.push(legend);
                } else if (typeof legend.elementId !== 'undefined' && legend.elementId.includes("relative-strength")){
                    let chart1Series = ProfileService.getSeries(legendName,0,0,0,ProfileService.getRelativeStrengthConfig(legend));
                    chart1.series.push(chart1Series);
                    if (!$.isEmptyObject(chart2)){
                        let chart2Series = ProfileService.getSeries(legendName,1,2,this.yAxisForChart2,ProfileService.getRelativeStrengthConfig(legend));
                        chart2.series.push(chart2Series);
                    }
                } else if (legend.symbolClass.includes("bar")){
                    let modifiedCompetitorConfig = isMatch == true ? 
                        JSON.parse(JSON.stringify(ProfileService.getDefaultClientSymbolConfig(this.symbolType))) :
                        JSON.parse(JSON.stringify(ProfileService.getCompetitorConfig("circle",symbolSize)));
                    $.extend(true, modifiedCompetitorConfig, ProfileService.getExpectationsConfig(chart1.containerId));
                    chart1.series.push(ProfileService.getSeries(legendName,0,0,0,modifiedCompetitorConfig));
                    if (!$.isEmptyObject(chart2)){                                    
                        chart2.series.push(ProfileService.getSeries(legendName,1,2,this.yAxisForChart2,modifiedCompetitorConfig));
                    }
                } else {
                    let modifiedCompetitorConfig = isMatch == true ? 
                        JSON.parse(JSON.stringify(ProfileService.getDefaultClientSymbolConfig(this.symbolType))) :
                        JSON.parse(JSON.stringify(ProfileService.getCompetitorConfig("circle",symbolSize)));
                    chart1.series.push(ProfileService.getSeries(legendName,0,0,0,modifiedCompetitorConfig));
                    if (!$.isEmptyObject(chart2)){                                    
                        chart2.series.push(ProfileService.getSeries(legendName,1,2,this.yAxisForChart2,modifiedCompetitorConfig));
                    }
                }
            }
        }
        chart1 = this.addAdditionalSeries(chart1,0,0,0);
        chart1 = this.reOrderSeries(chart1);
        chart1 = this.setChart(chart1Data, chart1);
        if (liftLegends.length > 0) {
            const inDemandIndex = liftLegends.findIndex(legend => legend.elementId === "in-demand");
            const repositionIndex = liftLegends.findIndex(legend => legend.elementId === "reposition");
            if (inDemandIndex > repositionIndex && repositionIndex >= 0) {
                const inDemandLegend = liftLegends.splice(inDemandIndex, 1)[0];
                liftLegends.splice(repositionIndex, 0, inDemandLegend);
            }
            liftLegends.push({ name: "Table Stake", symbolColor: "#A6A6A6" });
        }
        liftLegends.forEach(legend => {
            chart1.series.push(ProfileService.getLiftSeries(legend.name,0,0,0,legend.symbolColor,this.liftList,"functional",this.emotionalNeedNamesMap));
        });
        this.maximumAxisLabelWidth = this.findLongestStringLength(chart1.xAxis.data);
        if (this.maximumAxisLabelWidth >= 24){
            this.maximumAxisLabelWidth += 22;
        } else {
            this.maximumAxisLabelWidth += 10;
        }

        this.charts.push(chart1);
        if (!$.isEmptyObject(chart2Data)){
            chart2 = this.addAdditionalSeries(chart2,1,2,this.yAxisForChart2);
            chart2 = this.reOrderSeries(chart2);
            chart2 = this.setChart(chart2Data, chart2);
            let markPointSeries = {
                name: "Emotional Need Names",
                type: "scatter",
                xAxisIndex: 2,
                yAxisIndex: 2,
                gridIndex: 1,
            }
            $.extend(true, markPointSeries, ProfileService.getMarkPointForEmotionalNeeds(false,this.emotionalNeedNamesMap,dimensionTopLabelFirst,dimensionTopLabelSecond));
            chart2.series.push(markPointSeries);
            liftLegends.forEach(legend => {
                chart2.series.push(ProfileService.getLiftSeries(legend.name,1,2,this.yAxisForChart2,legend.symbolColor,this.liftList,"emotional",this.emotionalNeedNamesMap));
            });
            this.charts.push(chart2);
        }
    },
    reOrderSeries:function(chart){
        let reorderedSeries = [];
        let originalSeries = JSON.parse(JSON.stringify(chart.series));
        let relativeStrengthSeries = [];
        for (let i = 0; i < originalSeries.length; i++) {
            let series = originalSeries[i];
            if (typeof series.name != "undefined" && (series.name.includes("Strong+") || series.name.includes("Strong") || series.name.includes("Mild"))){
                relativeStrengthSeries.push(series);
            } else {
                reorderedSeries.push(series);
            }
        }
        for (let i = 0; i < relativeStrengthSeries.length; i++) {
            let series = relativeStrengthSeries[i];
            reorderedSeries.push(series);
        }
        chart.series = JSON.parse(JSON.stringify(reorderedSeries));
        return chart;
    },
    addAdditionalSeries: function(chart, gridIndex, xAxisIndex, yAxisIndex){
        if (chart && chart.series && chart.additionalSeries && Array.isArray(chart.additionalSeries)) {
            // loop through each additional series and add it to the chart's series array
            let additionalSeries = chart.additionalSeries;
            for (let i = 0; i < additionalSeries.length; i++) {
                let series = {
                    name: additionalSeries[i].name,
                    type: "scatter",
                    show: false,
                    gridIndex: gridIndex,
                    xAxisIndex: xAxisIndex,
                    yAxisIndex: yAxisIndex,
                    data: [],
                };  
                chart.series.push(series);
            }
        }
        return chart;
    },
    findLongestStringLength: function(stringsArray) {
        let maxLength = 0;
        stringsArray.forEach(str => {
            if (str.length > maxLength) {
                maxLength = str.length;
            }
        });
        return maxLength;
    },      
    padStringFront: function(inputString, numberOfSpaces) {
        let inputStringLength = inputString.length;
        let finalNumberOfSpaces = numberOfSpaces > inputStringLength ? numberOfSpaces - inputStringLength : numberOfSpaces;
        // Create a string of spaces with the specified length
        const padding = ' '.repeat(finalNumberOfSpaces);
        // Concatenate the padding to the front of the input string
        return padding + inputString;
    },    
    setChart: function(needsData, chart){
        chart = this.clearChart(chart);
        let xAxisData = [];
        let emotionalNeedsNameOrder = [];
        if (chart.containerId ===  "functional_needs_chart"){
            this.pricingPowerSeriesNumber = this.pricingPowerSeriesNumber + 1;
        }
        let isMatchChart = (chart.containerId === "profile_match_by_moat_functional_chart" || chart.containerId === "profile_match_by_need_functional_chart"
            || chart.containerId === "profile_match_by_moat_emotional_chart" || chart.containerId ===  "profile_match_by_need_emotional_chart" 
        ) ? true : false;

        let isPositiveCorrelation =  typeof chart.isPositiveCorrelation != "undefined" ? chart.isPositiveCorrelation : true;
        let additionalSeriesSeriesIndex = [];
        let relativeStrengthIndex = -2;
        let relativeStrengthSeriesList = [];
        const isRelativeStrengthMarkerSeries = series => {
            if (series == null || typeof series.name !== "string") {
                return false;
            }
            return series.name.startsWith("Strong+") || series.name.startsWith("Strong") || series.name.startsWith("Mild");
        };
        if (typeof chart.relativeStrengthSeriesIndexList !== "undefined" && chart.relativeStrengthSeriesIndexList !== null) {
            relativeStrengthSeriesList = JSON.parse(JSON.stringify(chart.relativeStrengthSeriesIndexList));
        }
        if (typeof chart.relativeStrengthIndex !== "undefined" && chart.relativeStrengthIndex !== null) {
            relativeStrengthIndex = chart.relativeStrengthIndex;
        }
        if (chart.additionalSeries && Array.isArray(chart.additionalSeries)) {
            // loop through and add 1 is displayPricingPower = false;
            if (this.displayPricingPower == false){
                for (let i = 0; i < chart.additionalSeries.length; i++) {
                    chart.additionalSeries[i].seriesNumber = chart.additionalSeries[i].seriesNumber + 1;
                }
            }
            // create an array of just the seriesNumber attribute
            additionalSeriesSeriesIndex = chart.additionalSeries.map(series => series.seriesNumber);
        }
        for (let needsIndex = 0; needsIndex < needsData.data.length; needsIndex++) {
            let companyProperties = needsData.data[needsIndex];
            // remove the pricing power value if displayPricingPower is false
            companyProperties = companyProperties.filter((value, index) => {
                if (this.displayPricingPower == false && index == this.pricingPowerSeriesNumber && index != 0){
                    return false;
                }
                return true;
            });
            if (companyProperties.length >= 3) {
                let seriesIndex = -1;
                for (let propertyIndex = 0; propertyIndex < companyProperties.length; propertyIndex++) {
                    //console.log("Name: " + companyProperties[0] + " Series Index: " + seriesIndex + " Property Index: " + propertyIndex);
                    let property = companyProperties[propertyIndex];
                    if (typeof property != 'undefined' && property != null ) {
                        // Skip the expectations gap for ByNeed functional and emotional needs charts
                        if (propertyIndex == 1 && (chart.containerId ===  "emotional_needs_chart" || chart.containerId ===  "functional_needs_chart")){
                            continue;
                        }
                        if (propertyIndex == 0){
                            let name = property;
                            let emotionalNeedNamesMapEntry = this.emotionalNeedNamesMap.find(rs => rs.needName === name);
                            if (typeof emotionalNeedNamesMapEntry != "undefined"){
                                if (chart.containerId !==  "value_emotional_needs_chart" && chart.containerId !==  "profile_match_by_value_emotional_chart"){
                                    name = emotionalNeedNamesMapEntry.dimensionName;
                                } 
                                emotionalNeedsNameOrder.push(name);
                                name = this.padStringFront(name, this.maximumAxisLabelWidth);
                            }
                            xAxisData.push(name.trim());
                        } else if (propertyIndex == 1){
                            chart.series[seriesIndex].data.push(property);
                        } else if (propertyIndex == 2){
                            chart.series[seriesIndex].data.push(property);
                        } else if (this.displayPricingPower && propertyIndex == this.pricingPowerSeriesNumber){
                            let pricingPower = companyProperties[this.pricingPowerSeriesNumber];
                            if (typeof pricingPower != 'undefined' && pricingPower != null ) {
                                if (pricingPower < 0){
                                    pricingPower = 0;
                                }
                                if (parseFloat(pricingPower) > parseFloat(this.maxPricingPower)){
                                    this.maxPricingPower = pricingPower;
                                }   
                                chart.series[seriesIndex].data.push(pricingPower);
                            }
                        } else if (relativeStrengthIndex == seriesIndex){
                            if (typeof chart.series[seriesIndex] != "undefined"){
                                let name = companyProperties[0];
                                //find the series index for the relative strength series
                                let seriesIndexForRelativeStrength = chart.series.findIndex(s => s.name === "Relative Strength");
                                if (seriesIndexForRelativeStrength != -1){
                                    let valueToDisplay = ProfileService.getRelativeStrengthDisplay(property,isPositiveCorrelation);
                                    chart.series[seriesIndexForRelativeStrength].data.push(valueToDisplay);
                                    
                                }                            
                                let seriesName = chart.series[seriesIndex].name;
                                let isEmotionalNeed = false;
                                let emotionalNeedNamesMapEntry = this.emotionalNeedNamesMap.find(rs => rs.needName === name);
                                if (typeof emotionalNeedNamesMapEntry != "undefined"){
                                    isEmotionalNeed = true;
                                    name = emotionalNeedNamesMapEntry.dimensionName;
                                }
                                let relativeStrengthEntry = this.relativeStrengthList.find(rs => rs.need === name);
                                if (typeof relativeStrengthEntry != "undefined"){
                                    // look up the strength name
                                    let strengthName = relativeStrengthEntry.strength
                                    // use that to find the proper index
                                    let relativeStrengthSeries = relativeStrengthSeriesList.find(rs => rs.strength === strengthName);
                                    // if you find the index them update the proper MarkPoint
                                    if (typeof relativeStrengthSeries != "undefined") {
                                        let markPointIndex = relativeStrengthSeries.seriesNumber;
                                        if (chart.containerId ===  "value_emotional_needs_chart"){
                                            markPointIndex = markPointIndex - 1;
                                        }
                                        if (typeof chart.series[markPointIndex].markPoint != "undefined" && chart.series[markPointIndex].markPoint != null) {
                                            if (Array.isArray(chart.series[markPointIndex].markPoint.data)) {
                                                if (!isNaN(property)){
                                                    property = Number(property).toFixed(2);
                                                }
                                                chart.series[markPointIndex].markPoint.data.push(ProfileService.getMarkPointDataForRelativeStrength(name,property,isEmotionalNeed,chart.containerId,emotionalNeedNamesMapEntry));
                                            }
                                        } 
                                    }
                                }
                            }
                        } else if (typeof chart.series[seriesIndex] !== "undefined" &&
                                (chart.series[seriesIndex].name === "Reposition" || chart.series[seriesIndex].name === "In-Demand")) {
                            // Lift values are rendered as fixed-position mark-point labels.
                        } else if (isRelativeStrengthMarkerSeries(chart.series[seriesIndex])) {
                            // Strong+/Strong are marker-only series. Their values are
                            // rendered through markPoint and must not become chart or tooltip points.
                        } else if (additionalSeriesSeriesIndex.includes(seriesIndex)){
                            if (typeof chart.series[seriesIndex] !== 'undefined' && typeof chart.series[seriesIndex].data !== 'undefined' && chart.series[seriesIndex].data !== null) {
                                 chart.series[seriesIndex].data.push(property);
                            }
                        } else if (seriesIndex < chart.series.length){
                            chart.series[seriesIndex].data.push(property);
                        }
                        seriesIndex++;
                    }
                }
            }            
        }
        if (chart.containerId ===  "functional_needs_chart"){
            if (!$.isEmptyObject(this.verbatimsData)) {
                let verbatimSeriesArray = ProfileService.getVerbatimSeries(0,0,0,"functional",this.verbatimsData);
                if (!$.isEmptyObject(verbatimSeriesArray)) {
                    chart.series.push(...verbatimSeriesArray);
                }
            }
        }
        if (chart.containerId ===  "functional_needs_chart" || chart.containerId === "profile_match_by_moat_functional_chart" || chart.containerId === "profile_match_by_need_functional_chart"){
            if (!$.isEmptyObject(this.topAttributeRecommendations)) {
                let topAttributeRecommendationsSeriesArray = ProfileService.getTopAttributeRecommendationsSeries(isMatchChart,0,0,0,"functional",this.topAttributeRecommendations,this.topAttributeRecommendationsLegendName);
                if (!$.isEmptyObject(topAttributeRecommendationsSeriesArray)) {
                    chart.series.push(...topAttributeRecommendationsSeriesArray);
                }
            }
        }
        if (chart.containerId ===  "emotional_needs_chart"){
            if (!$.isEmptyObject(this.verbatimsData)) {
                let verbatimSeriesArray = ProfileService.getVerbatimSeries(1,2,2,"emotional",this.verbatimsData);
                if (!$.isEmptyObject(verbatimSeriesArray)) {
                    chart.series.push(...verbatimSeriesArray);
                }
            }
        }
        if (chart.containerId ===  "emotional_needs_chart" || chart.containerId === "profile_match_by_moat_emotional_chart" || chart.containerId ===  "profile_match_by_need_emotional_chart"){
            if (!$.isEmptyObject(this.topAttributeRecommendations)) {
                let topAttributeRecommendationsSeriesArray = ProfileService.getTopAttributeRecommendationsSeries(isMatchChart,1,2,2,"emotional",this.topAttributeRecommendations,this.topAttributeRecommendationsLegendName);
                if (!$.isEmptyObject(topAttributeRecommendationsSeriesArray)) {
                    chart.series.push(...topAttributeRecommendationsSeriesArray);
                }
            }
        }
        if (chart.containerId ===  "moat_functional_needs_chart"){
            if (!$.isEmptyObject(this.verbatimsData)) {
                let verbatimSeriesArray = ProfileService.getVerbatimSeries(0,0,0,"functional",this.verbatimsData);
                if (!$.isEmptyObject(verbatimSeriesArray)) {
                    chart.series.push(...verbatimSeriesArray);
                }
            }
            if (!$.isEmptyObject(this.verbatimsData)) {
                let verbatimSeriesArray = ProfileService.getVerbatimSeries(1,2,2,"emotional",this.verbatimsData);
                if (!$.isEmptyObject(verbatimSeriesArray)) {
                    chart.series.push(...verbatimSeriesArray);
                }
            }
            if (!$.isEmptyObject(this.topAttributeRecommendations)) {
                let topAttributeRecommendationsSeriesArray = ProfileService.getTopAttributeRecommendationsSeries(isMatchChart,0,0,0,"functional",this.topAttributeRecommendations,this.topAttributeRecommendationsLegendName);
                if (!$.isEmptyObject(topAttributeRecommendationsSeriesArray)) {
                    chart.series.push(...topAttributeRecommendationsSeriesArray);
                }
            }
        }
        if (chart.containerId ===  "moat_functional_needs_chart" || chart.containerId === "profile_match_by_need_functional_chart"){
            if (!$.isEmptyObject(this.topAttributeRecommendations)) {
                let topAttributeRecommendationsSeriesArray = ProfileService.getTopAttributeRecommendationsSeries(isMatchChart,1,2,2,"emotional",this.topAttributeRecommendations,this.topAttributeRecommendationsLegendName);
                if (!$.isEmptyObject(topAttributeRecommendationsSeriesArray)) {
                    chart.series.push(...topAttributeRecommendationsSeriesArray);
                }
            }
        }
        if ("value_functional_needs_chart" == chart.containerId){
            if (!$.isEmptyObject(this.verbatimsData)) {
                let verbatimSeriesArray = ProfileService.getVerbatimSeries(0,0,0,"functional",this.verbatimsData);
                if (!$.isEmptyObject(verbatimSeriesArray)) {
                    chart.series.push(...verbatimSeriesArray);
                }
            }
        }
        if ("value_emotional_needs_chart" == chart.containerId){
            let mappingData = [
                {dimension: 'Assurance', value: 'Anxious'},
                {dimension: 'Activity', value: 'Detached'},
                {dimension: 'Trust', value: 'Tough-Minded'},
                {dimension: 'Creativity', value: 'Practical'},
                {dimension: 'Adaptability', value: 'Flexible'}
            ];
            if (!$.isEmptyObject(this.verbatimsData)) {
                let modifiedVerbatimsData = JSON.parse(JSON.stringify(this.verbatimsData));
                for (let i = 0; i < modifiedVerbatimsData.length; i++) {
                    let verbatimData = modifiedVerbatimsData[i];
                    if (verbatimData.needType == "emotional") {
                        for (let j = 0; j < verbatimData.needs.length; j++) {
                            let need = verbatimData.needs[j];
                            let mappingEntry = mappingData.find(entry => entry.dimension === need);
                            if (typeof mappingEntry != "undefined") {
                                verbatimData.needs[j] = mappingEntry.value;
                            }
                        }
                    }
                }
                let verbatimSeriesArray = ProfileService.getVerbatimSeries(0,0,0,"emotional",modifiedVerbatimsData,true);
                if (!$.isEmptyObject(verbatimSeriesArray)) {
                    chart.series.push(...verbatimSeriesArray);
                }
            }
        }
        if ("moat_functional_needs_chart" == chart.containerId || "profile_match_by_moat_functional_chart" == chart.containerId){
            chart.xAxis.splitLine.lineStyle.width = 4;
        }
        if ("emotional_needs_chart" == chart.containerId || "profile_match_by_need_emotional_chart" == chart.containerId){
            this.emotionalNeedsNameOrder = ProfileService.setEmotionalNeedsHeaderOrder(chart.header.data, emotionalNeedsNameOrder);
        }
        if ("value_emotional_needs_chart" == chart.containerId || "profile_match_by_value_emotional_chart" == chart.containerId){
            for (let i = 0; i < chart.series.length; i++) {        
                chart.series[i].data.reverse();
            }    
        }
        chart.xAxis.data = JSON.parse(JSON.stringify(xAxisData));
        return chart;
    },
    getChartOptions: function(){
        let options = {};
        let showToolbox =  !(ReportService.getReportAutoChartGenerateStatus() == "generate");
        let colorPaletteId = this.eChartCriteria.colorPaletteId;
        //let showLegend = this.eChartCriteria.showLegend;
        let showLegend = true;
        let showLabel = false;
        let angleText = true;
        let isMultipleWaves = true;
        let displayNumberOfRespondents = this.eChartCriteria.displayNumberOfResponses;
        let showTooltip = this.eChartCriteria.showTooltip;
/* Start of function that should go into helper service */
        let xAxis = [];
        let seriesData = [];
        for (let i = 0; i < this.charts.length; i++) {
            let chart = this.charts[i];
            for (let i = 0; i < chart.series.length; i++) {
                let series = chart.series[i];
                seriesData.push(series);
            }
            $.extend(true, chart.xAxis.axisLabel, ProfileService.getDefaultAxisTextStyleForAnalyticChart());
            if (angleText == true){           
                $.extend(true, chart.xAxis.axisLabel, {rotate: 25,hideOverlap: true,interval: 0});
            } else {
                let defaultAxisLabel = {
                    overflow: "break",
                    interval: 0,
                    width: 40,
                    ellipsis: '...',        
                    rotate: 0,
                    hideOverlap: false,
                };
                $.extend(true, chart.xAxis.axisLabel, defaultAxisLabel);
            }
            xAxis.push(chart.xAxis);
            xAxis.push(chart.header);
        }
/* End of function that should go into helper service */
        ScatterService.setShowSnap(this.isSavedCard);
        ScatterService.setShowToolbox(showToolbox);
        ScatterService.setColorPaletteId(colorPaletteId);
        ScatterService.setShowLabel(showLabel);
        ScatterService.setShowLegend(showLegend);
        ScatterService.setIsMultiWave(isMultipleWaves);
        ScatterService.setChartType(this.eChartCriteria.eChartType);
        let legendData = ProfileService.buildLegendData(this.legend,displayNumberOfRespondents,this.verbatimsData,this.topAttributeRecommendations,this.topAttributeRecommendationsLegendName);
        ScatterService.setLegendData(legendData);
        ScatterService.setSeriesData(seriesData);
        if (this.eChartCriteria.eChartType == "stacked-bar-vertical"){
            let displayPricingPowerLabel = "value_functional_needs_chart" == this.charts[0].containerId || "profile_match_by_value_functional_chart" == this.charts[0].containerId;
            ScatterService.setYAxis(ProfileService.getYAxis(Math.ceil(this.maxPricingPower),this.charts.length,this.displayPricingPower,displayPricingPowerLabel,this.pricingPowerColor));
            ScatterService.setXAxis(xAxis);
        } else if (this.eChartCriteria.eChartType == "bar-horizontal"){
            let left = [];
            let right = [];
            for (let i = 0; i < this.charts[0].xAxis.data.length; i++) {
                let emotionalName = this.charts[0].xAxis.data[i].split(","  );
                left.push(emotionalName[1]);
                right.push(emotionalName[0]);
            }
            left.reverse();
            right.reverse();
            let emotionalNeedNames = [];
            emotionalNeedNames.push(left);
            emotionalNeedNames.push(right);
            emotionalNeedNames.push(this.driverNames);
            ScatterService.setYAxis(ProfileService.getYAxisForValueDrivers(emotionalNeedNames));
            ScatterService.setXAxis(ProfileService.getXAxisForValueDrivers());
        }
        options = ScatterService.getOptions(this,this.modalId, this.inputReportTypeName,this.inputDownloadFileName);
        options.tooltip.show = showTooltip;
        if (!$.isEmptyObject(options)) { 
            //override normal options
            options.tooltip.formatter = ProfileService.toolTipForProfileAreaChart;
            options.tooltip.backgroundColor = "#ffffff";
            options.color = this.colors;
            if (options.series.length > 1){
                options.series[1].label.color = "#2F5EB3";            
            }
            $.extend(true, options.toolbox, ProfileService.getToolboxForAnalyticsChart());
        }
        return options;           
    },
    getHeaderWidths: function(tickCoordinates){
        let headerWidths = [];
        for (let i = 0; i < tickCoordinates.length; i++) {
            let width = 0;
            let coord = tickCoordinates[i];
            if (i == 0){
                width = coord - 0;
            } else {
                width = coord - tickCoordinates[i-1];
            }
            headerWidths.push(width);
        }
        return headerWidths;
    },
    getStringWidth: function (text, font = '16px Arial') {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font;
        return context.measureText(text).width;
    },
    updatedWinnerHeaderSeries: function(headerSeries,names,numberOfNeeds){
        let populatedNames = names.filter(name => name != ' ');
        if (populatedNames.length == 1 && headerSeries.markArea.data.length > 0 && headerSeries.markArea.data[0].length > 0){
            headerSeries.markArea.data[0][0].label.width = 600;
            headerSeries.markArea.data[0][0].label.name = populatedNames[0];        
            headerSeries.markArea.data[0][0].label.formatter =  "{a|"+populatedNames[0]+"}";
            headerSeries.markArea.data[0][0].xAxis = "1";
            numberOfNeeds = numberOfNeeds - 1;
            headerSeries.markArea.data[0][1].xAxis = numberOfNeeds;
        }
        headerSeries.markArea.data.pop();
        headerSeries.markArea.data.pop();

        return headerSeries;
    },
    updatedHeaderSeries: function(headerSeries,ticksIndex,displayType){
        let needTickCoordinates = this.chart._model._componentsMap.get('xAxis')[ticksIndex].axis.getTicksCoords();
        let tickCoordinates = needTickCoordinates.map(function (tick) {
            return tick.coord;
        });
        let headerWidths = this.getHeaderWidths(tickCoordinates);
        for (let i = 0; i < headerSeries.markArea.data.length; i++) {
            if (displayType == "winner" || displayType == "match-winner"){
                if(i == 0) {
                    headerSeries.markArea.data[i][0].label.width = headerWidths[i]-3;
                } else {
                    headerSeries.markArea.data[i][0].label.width = headerWidths[i]-3.5;
                }
            } else if (displayType == "need-emotional"){                
                headerSeries.markArea.data[i][0].label.width = 200;
            } else {
                if(i == 0) {
                    headerSeries.markArea.data[i][0].label.width = headerWidths[i]-2;
                } else {
                    headerSeries.markArea.data[i][0].label.width = headerWidths[i]-4;
                }
            }
            let valueWidth = this.getStringWidth(headerSeries.markArea.data[i][0].name);
            let labelWidth = headerSeries.markArea.data[i][0].label.width;
            let isValueGreaterLabel =  (valueWidth-50) > labelWidth;
            
            if (isValueGreaterLabel){
                let newName = headerSeries.markArea.data[i][0].name;
                let differencePercent = labelWidth / valueWidth;
                let substrValue = Math.ceil(newName.length * differencePercent);
                newName = newName.substr(0, substrValue-1) + "…";    
                headerSeries.markArea.data[i][0].name = newName;
                headerSeries.markArea.data[i][0].label.formatter = "{a|"+newName+"}";
            }
            if (i == 0){
                if (displayType == "value" || displayType == "match-value"){
                    headerSeries.markArea.data[i][0].label.offset = [12.25,0];
                } else if (displayType == "need-emotional"){
                    headerSeries.markArea.data[i][0].label.offset = [9.75,0];
                } else if (displayType == "winner" || displayType == "match-winner"){
                    headerSeries.markArea.data[i][0].label.offset = [9,0];
                } else if (displayType == "moat" || displayType == "match-moat"){
                    headerSeries.markArea.data[i][0].label.offset = [6,0];
                } else {
                    headerSeries.markArea.data[i][0].label.offset = [8.5,0];
                }
            } 
            if (displayType == "moat"){
                headerSeries.markArea.data[i][0].label.backgroundColor = "#4d8352";
            }            
        }
        return headerSeries;
    },
    processChart: async function(runChart = false,displayType,needsData,eChartCriteria,displayPricingPower = false,matchType = ""){
        if (runChart == true) {
            await this.getDefaultSymbol();
            if (matchType != ""){
                this.matchType = matchType;
            }
            let emotionalNeedsBreakPointList = [0,1,2,3];
            if (typeof eChartCriteria != "undefined") {
                this.eChartCriteria = JSON.parse(JSON.stringify(eChartCriteria));
            }
            this.displayPricingPower = displayPricingPower;
            this.maxPricingPower = 0;
            let driverList = [];
            if (typeof needsData != "undefined" && typeof needsData.driverList != "undefined") {
                driverList = JSON.parse(JSON.stringify(needsData.driverList));
            }

            // get the splits for charts
            let breakPointList = [];
            if (typeof needsData != "undefined" && typeof needsData.breakPointList != "undefined") {
                breakPointList = JSON.parse(JSON.stringify(needsData.breakPointList));
            }
            this.verbatimsData = {};
            if (typeof needsData != "undefined" && typeof needsData.verbatims != "undefined") {
                this.verbatimsData = JSON.parse(JSON.stringify(needsData.verbatims));
            }
            this.topAttributeRecommendations = {};
            if (typeof needsData != "undefined" && typeof needsData.topAttributeRecommendations != "undefined") {
                this.topAttributeRecommendations = JSON.parse(JSON.stringify(needsData.topAttributeRecommendations));
            }
            this.topAttributeRecommendationsLegendName = "Value Suggestions";
            if (typeof needsData != "undefined" && typeof needsData.topAttributeRecommendationsLegendName != "undefined") {
                this.topAttributeRecommendationsLegendName = needsData.topAttributeRecommendationsLegendName;
            }
            let needsList = [];
            if (typeof needsData != "undefined" && typeof needsData.needsList != "undefined") {
                needsList = JSON.parse(JSON.stringify(needsData.needsList));
                needsList = needsList.filter(function (need) {
                    return need.needName != "";
                });
            }
            let numberOfNeeds = needsList.length;
            let emotionalNeedNames = [];
            if (displayType == "moat" || displayType == "match-moat"){
                let names = ['Value','Design','Scale','Time','Routine','Network','Skill','Lock-In','Lock-Out','Upstart','Brand'];
                let headerGroups = ['Core Moats', 'Rocket Moats', 'Pioneer Moats'];
                numberOfNeeds = 12;
                breakPointList = [2,8];
                let chart1 = {
                        containerId: "",
                        header: ProfileService.getBaseNeedsHeader(breakPointList,numberOfNeeds,displayType),
                        series: [],
                        xAxis: ProfileService.getXAxisForNeeds(displayType,breakPointList,true),                
                };
                let chart2 = {
                    containerId: "",
                    header: ProfileService.getEmotionalNeedsHeader(emotionalNeedsBreakPointList,5),
                    series: [],
                    xAxis:  ProfileService.getXAxisForEmotionalNeeds(),       
                };
                if (typeof needsData != "undefined" && typeof needsData.chart2 != "undefined" && typeof needsData.chart2.emotionalNeedNames != "undefined") {
                    emotionalNeedNames = JSON.parse(JSON.stringify(needsData.chart2.emotionalNeedNames));
                } 
                ScatterService.setGrid(ProfileService.getGridForProfileByNeedChart());
                this.setDataForNeed(needsData,chart1,chart2,displayType,emotionalNeedNames);
                chart1.series.push(ProfileService.getMoatHeaderSeries(displayType,names,numberOfNeeds,0,1,0,this.displayPricingPower,headerGroups,ScatterService.getGrid()));
                numberOfNeeds = 5;
                names = emotionalNeedNames.map(emotionalNeed => emotionalNeed.dimensionName);
                headerGroups = ['Emotional Levels'];
                let series = ProfileService.getMoatHeaderSeries(displayType,names,numberOfNeeds,1,3,this.yAxisForChart2,this.displayPricingPower,headerGroups,ScatterService.getGrid());
                series.markLine = ProfileService.getDefaultMarkLineForEmotionalNeeds();
                chart2.series.push(series);
                this.initChart();
            } else if (displayType == "need" || displayType == "match-need"){
                let chart1 = {
                    containerId: "",
                    header: ProfileService.getFunctionalNeedsHeader(breakPointList,numberOfNeeds,displayType),
                    series: [],
                    xAxis: ProfileService.getXAxisForNeeds(displayType,breakPointList),                
                };
                let chart2 = {
                    containerId: "",
                    header: ProfileService.getEmotionalNeedsHeader(emotionalNeedsBreakPointList,5),
                    series: [],
                    xAxis:  ProfileService.getXAxisForEmotionalNeeds(),       
                };
                if (typeof needsData != "undefined" && typeof needsData.chart2 != "undefined" && typeof needsData.chart2.emotionalNeedNames != "undefined") {
                    emotionalNeedNames = JSON.parse(JSON.stringify(needsData.chart2.emotionalNeedNames));
                } 
                ScatterService.setGrid(ProfileService.getGridForProfileByNeedChart());

                this.setDataForNeed(needsData,chart1,chart2,displayType,emotionalNeedNames);
                let names = ["Top Quartile","Second Quartile","Third Quartile","Fourth Quartile"];
                chart1.series.push(ProfileService.getBaseNeedsHeaderSeries(names,breakPointList,numberOfNeeds,0,1,0));
                numberOfNeeds = 1;
                emotionalNeedsBreakPointList = [0];
                this.emotionalNeedsNameOrder = ['Emotional Levels'];
                let emotionalNeedsHeaderSeries = ProfileService.getBaseNeedsHeaderSeries(this.emotionalNeedsNameOrder,emotionalNeedsBreakPointList,numberOfNeeds,1,3,this.yAxisForChart2,0,true);
                emotionalNeedsHeaderSeries.markArea.data[0][0].label.width = 200;                
                emotionalNeedsHeaderSeries.markArea.data[0][1].xAxis = 5;
                chart2.series.push(emotionalNeedsHeaderSeries);
                this.initChart();
                let headerSeries = this.updatedHeaderSeries(chart1.series[chart1.series.length-1],1,displayType);
                chart1.series.pop();
                chart1.series.push(headerSeries);
                let emotionalHeaderSeries = this.updatedHeaderSeries(chart2.series[chart2.series.length-1],3,"need-emotional");
                chart2.series.pop();
                chart2.series.push(emotionalHeaderSeries);
                this.initChart();
            } else if (displayType == "winner" || displayType == "match-winner"){
                let chart1 = {
                    containerId: "",
                    header: ProfileService.getWinnersHeader(breakPointList,numberOfNeeds,displayType),
                    series: [],
                    xAxis: ProfileService.getXAxisForNeeds(displayType,breakPointList),                
                };
                ScatterService.setGrid(ProfileService.getGridForSingleChart());
                this.setDataForNeed(needsData,chart1,{},displayType,emotionalNeedNames);
                let names = [];
                let onlyDisplayOneWinnerName = false;
                let defaultWidth = 0;
                if (typeof needsData != "undefined" && typeof needsData.winnerMapNames != "undefined") {
                   names = JSON.parse(JSON.stringify(needsData.winnerMapNames));
                   defaultWidth = needsData.winnerMapNames.filter(name => name != ' ').length > 1 ? 0 : 450;
                   onlyDisplayOneWinnerName = needsData.winnerMapNames.filter(name => name != ' ').length == 1;
                }                
                
                chart1.series.push(ProfileService.getBaseNeedsHeaderSeries(names,breakPointList,numberOfNeeds,0,1,0,defaultWidth));
                this.initChart();
                if (names.length > 1){
                    let headerSeries = onlyDisplayOneWinnerName ? this.updatedWinnerHeaderSeries(chart1.series[chart1.series.length-1], names,numberOfNeeds) : 
                                this.updatedHeaderSeries(chart1.series[chart1.series.length-1],1,displayType,onlyDisplayOneWinnerName);
                    chart1.series.pop();
                    chart1.series.push(headerSeries);
                    this.initChart();
                }
            } else if (displayType == "value" || displayType == "match-value"){
                let chart1 = {
                    containerId: "",
                    header: ProfileService.getWinnersHeader(breakPointList,numberOfNeeds,displayType),
                    series: [],
                    xAxis: ProfileService.getXAxisForNeeds(displayType,breakPointList),                
                };
                let grid = ProfileService.getGridForSingleChart();
                ScatterService.setGrid(grid);
                this.setDataForNeed(needsData,chart1,{},displayType,emotionalNeedNames);
                let names = driverList.map(driver => driver.name);
                chart1.series.push(ProfileService.getBaseNeedsHeaderSeries(names,breakPointList,numberOfNeeds,0,1,0));
                this.initChart();
                let headerSeries = this.updatedHeaderSeries(chart1.series[chart1.series.length-1],1,displayType);
                chart1.series.pop();
                chart1.series.push(headerSeries);
                this.initChart();
            } else if (displayType == "value-driver" || displayType == "match-value-driver"){
                this.driverNames = driverList.map(driver => driver.name).reverse();
                let chart1 = {
                    containerId: "",
                    header: ProfileService.getWinnersHeader(breakPointList,numberOfNeeds,displayType),
                    series: [],
                    xAxis: ProfileService.getXAxisForNeeds(displayType,breakPointList),                
                };
                ScatterService.setGrid(ProfileService.getGridForValueDriverChart());
                this.setDataForNeed(needsData,chart1,{},displayType,emotionalNeedNames);
                chart1.series.push(...ProfileService.getValueDriverHeaderSeries(0,0,0));
                this.initChart();
            }
            if (typeof needsData != "undefined" && typeof eChartCriteria != "undefined" && this.charts.length > 0) {
                this.$emit('save-criteria',true);
                this.$emit('save-table');
                if(needsData?.chart2?.emotionalNeedNames) {
                    this.$emit('update-recommendation-data', needsData.chart2.emotionalNeedNames);
                }
            }
        }
    },
  },
  watch: {},
};
</script>
